module.exports = __webpack_public_path__ + "hM0gekQOUVruWAbHF/icon_info.svg";